export enum DPApps {
  p2 = 'p2',
  flows = 'flows',
  mrm = 'mrm',
  swish_out = 'swish_out',
  template = 'template',
}
